import React, { useState, useEffect } from 'react';
import './App.css';
import emailjs from '@emailjs/browser';
import AboutMeBox from './components/AboutMeBox';
import Project from './components/Project';
import { KnowledgeBase } from './KnowledgeBase/KnowledgeBase';
import Flashcard from './components/Flashcard/Flashcard';
import Contact from './Contact/Contact';
import Nav from './components/Nav/Nav';
import Background from './components/Background/Background';
import SectionAnimation from './SectionAnimation/SectionAnimation';
import { AnimationProvider } from './SectionAnimation/AnimationContext';
import ProgressBar from './ProgressBar/ProgressBar';

// Initialize EmailJS
emailjs.init("jmk_eM55IRvSvig4C");

function App() {
  const [showSimplified, setShowSimplified] = useState(false);
  const [titleVisible, setTitleVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const sections = [
    { id: 'intro', label: 'Introduction', icon: '👋' },
    { id: 'projects', label: 'Projects', icon: '💼' },
    { id: 'knowledge', label: 'Knowledge Base', icon: '🧠' },
    { id: 'contact', label: 'Contact', icon: '📬' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Show title when scrolled to top, hide when scrolled down
      if (window.scrollY === 0) {  // Exactly at the top
        setTitleVisible(true);
      } else if (window.scrollY > 10 && titleVisible) {  // Scrolled down past threshold
        setTitleVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [titleVisible]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Define a breakpoint for mobile
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <AnimationProvider>
      <div className="container">
        <Background />
        <Nav />
        <h5 className={`welcome-title ${!titleVisible ? 'hidden' : ''}`}>
          Welcome to My Portfolio Page!
        </h5>
        <ProgressBar sections={sections} />
        
        <div id="intro">
          <SectionAnimation initialLoad={true} sectionId="intro">
            <div className="introduction-wrapper">
              <div className="introduction-section">
                <AboutMeBox />
              </div>
            </div>
          </SectionAnimation>
        </div>

        <div id="projects">
          <SectionAnimation delay={0.2} sectionId="projects">
            <div className="project-section">
              <Project />
            </div>
          </SectionAnimation>
        </div>

        <div id="knowledge">
          <SectionAnimation delay={0.3} sectionId="knowledge">
            <div className="knowledge-base-section">
              <div className="knowledge-header">
                <h2>Knowledge Base</h2>
                {!isMobile && (
                  <button 
                    className="simplify-toggle"
                    onClick={() => setShowSimplified(!showSimplified)}
                  >
                    {showSimplified ? 'Show 3D View' : 'Simplify View'}
                  </button>
                )}
              </div>
              <div className="knowledge-content">
                <div className={`knowledge-layout ${showSimplified || isMobile ? 'simplified' : ''}`}>
                  {showSimplified || isMobile ? (
                    <Flashcard onItemClick={() => {}} />
                  ) : (
                    <KnowledgeBase />
                  )}
                </div>
              </div>
            </div>
          </SectionAnimation>
        </div>

        <div id="contact">
          <SectionAnimation delay={0.4} sectionId="contact">
            <div className="contact-section-wrapper">
              <Contact />
            </div>
          </SectionAnimation>
        </div>
      </div>
    </AnimationProvider>
  );
}

export default App;
